<template>
  <div id="ledger_txs_by_result_container" v-bind:class="$mq">
    <div id="ledger_txs_by_result" v-show="have_txs">

      <p><b>Txs By Result</b></p>
      <hr/>

      <table style="text-align: right; width: 100%">
        <tr v-for="result in results" v-bind:key="result">
          <td>{{txs_by_result[result]}}</td>
          <td>{{result}}</td>
        </tr>

        <tr v-for="i in filler_lines" v-bind:key="'filler' + i">
          <td>&nbsp;</td>
        </tr>
      </table>

      <apexchart type=pie
                 v-bind:options="chart_options"
                 v-bind:series="chart_data"
                 height="250"
                 style="margin-top: 10px; padding-top: 20px; background: #eef1f6"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LedgerTxsByResult',

  props : {
    ledger : Object
  },

  computed : {
    have_txs : function(){
      return this.ledger.transactions;
    },

    txs : function(){
      return this.ledger.transactions || [];
    },

    results : function(){
      return Array.from(new Set(this.txs.map(function(tx){
        return tx.metaData.TransactionResult;
      })));
    },

    // XXX: to align chart w/ LedgerTxsByType chart
    filler_lines : function(){
      if(this.results.length >= 5) return 0;
      return 5 - this.results.length;
    },

    txs_by_result : function(){
      var by_result = {};
      this.results.forEach(function(result){
        by_result[result] = this.num_of(result);
      }.bind(this));
      return by_result;
    },

    chart_data : function(){
      return Object.values(this.txs_by_result);
    },

    chart_options : function(){
      return {labels: Object.keys(this.txs_by_result), legend: {position : 'bottom'}};
    }
  },

  methods : {
    num_of: function(result){
      return this.txs.filter(function(tx){
        return tx.metaData.TransactionResult == result;
      }).length;
    }
  }
}
</script>

<style scoped>
#ledger_txs_by_result_container{
  background-color: white;
  min-height: 100%;
  border-left: 1px solid #cccccc;
}

#ledger_txs_by_result_container.sm,
#ledger_txs_by_result_container.md{
  border-top: 1px solid #cccccc;
}

#ledger_txs_by_result{
  padding: 10px;
  height: 100%;
  overflow-x: auto;
}
</style>
